import { LucideInfo } from 'lucide-react'
import { Flex, Text } from 'ui'
import { TimelineShift } from 'api/shift'
import { WorkShift } from 'typings/common_defs'

interface Props {
  shift: TimelineShift | WorkShift
}

/**
 * Clarifying note shown wherever a business-portal user invites/requests
 * specific workers on a shift that's part of a bundled listing. Workers
 * generally accept bundled listings as a group rather than shift-by-shift.
 */
export const BundledInviteNote = ({ shift }: Props) => {
  const bundleSize = shift.bundleMetadata?.bundleSize ?? 0

  if (shift.isTryout || !shift.bundleMetadata || bundleSize <= 1) {
    return null
  }

  return (
    <Flex alignItems="center" mt={1}>
      <LucideInfo size={14} />
      <Text fontSize={1} color="lightText" ml={1}>
        This shift is part of a bundled listing of {bundleSize} shifts.
        Workers generally accept bundled listings as a group.
      </Text>
    </Flex>
  )
}
